import type { UTCDate } from '@date-fns/utc';
import { addMonths, format, isAfter, parse } from 'date-fns';

import type {
  CompositionV3Filters,
  SentimentV3Filters,
} from '@revelio/data-access';

import { getFormattedDateString } from './dateUtils';

export const buildMonthRefsInclusive = (
  startYYYYMM: string,
  endYYYYMM: string
): string[] => {
  const start = parse(startYYYYMM, 'yyyy-MM', new Date());
  const end = parse(endYYYYMM, 'yyyy-MM', new Date());
  const months: string[] = [];
  let cur = start;
  while (!isAfter(cur, end)) {
    months.push(format(cur, 'yyyy-MM'));
    cur = addMonths(cur, 1);
  }
  return months;
};

export const getMonthRefsFromV3Filters = (
  filters: CompositionV3Filters | SentimentV3Filters
): string[] => {
  const { start_date, end_date } = filters;
  if (!start_date || !end_date) {
    return [];
  }
  return buildMonthRefsInclusive(start_date, end_date);
};

export const getV3MonthRefs = ({
  availableDateRange,
  filters,
}: {
  availableDateRange?: {
    month?: { min?: UTCDate | null; max?: UTCDate | null };
  } | null;
  filters: CompositionV3Filters | SentimentV3Filters;
}): string[] => {
  const systemMin = availableDateRange?.month?.min;
  const systemMax = availableDateRange?.month?.max;
  if (systemMin && systemMax) {
    return buildMonthRefsInclusive(
      getFormattedDateString(systemMin, 'month'),
      getFormattedDateString(systemMax, 'month')
    );
  }
  return getMonthRefsFromV3Filters(filters);
};
